import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllEmailAlertConfig = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllEmailSetting}?companyCode=${companyCode}`
  );
  return data;
};

const getAllEmailModules = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllEmailModule}` //?companyCode=${companyCode}
  );
  return data;
};

const getEmailAlertConfigById = async ({ code, companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetEmailSetting}?ID=${code}&companyCode=${companyCode}`
  );
  return data;
};

const insertEmailAlertConfig = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertEmailSetting,
    input
  );
  return data;
};

const updateEmailAlertConfig = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateEmailSetting,
    input
  );
  return data;
};

// const deleteEmailAlertConfig = async ({ companyCode, code }) => {
//   const { data } = await http_payroll.delete(
//     `${Api_EndPoints.EmailAlertConfigAPI}?CompanyCode=${companyCode}&Code=${code}`
//   );
//   return data;
// };

export const useGetEmailAlertConfigsQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllEmailSetting],
    queryFn: () => getAllEmailAlertConfig(companyCode),
    refetchOnWindowFocus: false,
  });
};

export const useGetEmailAlertConfigByIdQuery = (input) => {
  return useQuery({
    queryKey: [`${Api_EndPoints.GetEmailSetting}?ID=${input.code}`],
    queryFn: () => getEmailAlertConfigById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertEmailAlertConfigMutation = () => {
  return useMutation({
    mutationFn: insertEmailAlertConfig,
  });
};

export const useUpdateEmailAlertConfigMutation = () => {
  return useMutation({
    mutationFn: updateEmailAlertConfig,
  });
};

// export const useDeleteAcademicMutation = () => {
//   return useMutation({
//     mutationFn: deleteAcademic,
//   });
// };

export const useGetAllEmailModulesQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllEmailModule],
    queryFn: () => getAllEmailModules(companyCode),
    refetchOnWindowFocus: false,
  });
};
